module.exports = __webpack_public_path__ + "img/Test.161f65a5.jpg";